export const STICKY_DELAY = 200;
export const STICKY_EVENT_TYPE_SUCCESS = 'success';
export const STICKY_EVENT_TYPE_WARNING = 'warning';
export const STICKY_EVENT_TYPE_ERROR = 'error';
export const STICKY_EVENT_TYPE_COMPONENT = 'component';
